import React from 'react'

import { Anesthesia } from './components/Anesthesia'
import { Postcare } from './components/Postcare'
import { Preparation } from './components/Preparation'

export const AmbulantOperation = () => {
    return (
        <div className="flex flex-col justify-center items-center">
            <Preparation classname="max-w-container-s" />
            <Anesthesia className="max-w-container-s" />
            <Postcare className="max-w-container-s" />
        </div>
    )
}
